import { useTranslation } from "react-i18next";
import TransactionAmount from "../TransactionAmount";
import RandomTaskTime from "../RandomTaskTime";

import "./index.less"
import SlipForm from "@/components/SlipForm";
import StopWay from "../StopWay";

export default function SwapParamsSetting({ form, tokenAInfo, queryOtherTokenInfo, otherTokenInfo, isTokenANativeOrStable, isTokenBNativeOrStable }: any) {
  const { t } = useTranslation();
  return (
    <div className="swap-params-setting">
      <h4>{t("batchSwap.swapParamsSetting")}</h4>
      <TransactionAmount form={form} tokenAInfo={tokenAInfo} />
      <RandomTaskTime form={form} />
      <SlipForm form={form} />
      <StopWay form={form} otherTokenInfo={otherTokenInfo} queryOtherTokenInfo={queryOtherTokenInfo} isTokenANativeOrStable={isTokenANativeOrStable} isTokenBNativeOrStable={isTokenBNativeOrStable} />
    </div>
  )
}